<template>
  <body style="max-width:1000px;margin:0 auto;">
    <div class="top" v-if="this.topimg">
      <img :src="topimg" alt="" class="top-img">
    </div>
    <div class="banner">
      <div class="banner-item" v-for="(item,index) in shopList" :key="index" @click="godetail(item)">
        <div class="item-in">
          <div class="wai-img">
            <img :src="item.goods_thumb" alt="" class="in-img" />
          </div>
          <div class="in-name">{{ item.goodsname }}</div>
       <div class='in-price' v-if="item.market_integral"><span style="color:red;">{{ item.market_integral }}</span></div>
        </div>
      </div>
    </div>
  </body>
</template>


<script>
  import wx from "weixin-js-sdk";
  export default {
    data() {
      return {
        is_loading: true,
        shopList: [],
        goodinfo: "",
        huace_id: '',
        gift_id: '',
        topimg: '',
        info: []
      }
    },
    methods: {
      // 页面初始化
      initshow() {
        let app = this;
        var huace_id = this.$route.query.id;

        //修正之前的礼品册id用的goods_id的问题
        if (this.$route.query.goods_id) {
          var gift_id = this.$route.query.goods_id;
        } else {
          var gift_id = this.$route.query.gift_id;
        }
        this.huace_id = huace_id
        this.gift_id = gift_id

        var token = localStorage.getItem("token");
        this.$http
          .get(
            api_url + `action=getGoodsListByGiftListID&id=${gift_id}&token=${token}`
          )
          .then(res => {
            console.log(res)
            app.shopList = res.data.res.goods_list
            app.topimg = res.data.res.goods_list_image
            app.info = res.data.res
          })


        //微信分享
        this.wechatShare()
      },
      godetail(item) {
        //id是画册的id
        var id = this.$route.query.id;
        var goods_id = item.id
        this.$router.push({
          path: "/detail",
          query: {
            id: id,
            goods_id: goods_id
          },
        });
      },
      //微信分享
      wechatShare() {
        var app = this;
        var id = this.$route.query.id;
        var token = localStorage.getItem("token");
        //必须要url编码，如果不编码，url的参数值里面有&拼接会被当做接口参数以及参数值，再次发送
        let url = encodeURIComponent(window.location.href);
        var pathUrl =
          api_url + `action=get_wxshare_param&id=${id}&token=${token}&url=${url}`;
        this.$http
          .request({
              url: pathUrl,
            },
            "GET"
          )
          .then((res) => {
            console.log("get_wxshare_param", res);
            if (res.data.sta == 200) {
              let data = res.data;

              //设置网页标题
              document.title = res.data.res.share_title;
              //通过config接口注入权限验证配置
              wx.config({
                debug:  data.res.is_debug_fx,
                appId: data.res.appId,
                timestamp: data.res.timestamp,
                nonceStr: data.res.nonceStr,
                signature: data.res.signature,
                jsApiList: [
                  "updateTimelineShareData",
                  "updateAppMessageShareData",
                  "showAllNonBaseMenuItem",
                  "hideAllNonBaseMenuItem",
                  "showMenuItems",
                  "onMenuShareAppMessage",
                  "onMenuShareTimeline",
                ],
              });
              //console.log(data.res.appId)
              //console.log(data.res.timestamp)
              //console.log(data.res.nonceStr)
              // console.log(data.res.signature)

              //通过ready接口处理成功验证
              wx.ready(function() {
                //展示所有基础类型按钮，20211012日，微信增加了直接访问网址，出现一个拦截，这种情况下不显示分享按钮，先收藏然后在分享就可以，bug
                wx.showAllNonBaseMenuItem();
                /*
                wx.hideAllNonBaseMenuItem();
                wx.showMenuItems({
                menuList: ["menuItem:share:appMessage", "menuItem:share:timeline",
                "updateAppMessageShareData", "updateAppMessageShareData"
                ] // 要显示的菜单项，所有menu项见附录3
                });*/
                /*
                //注释掉新版，旧的才会生效
                wx.updateAppMessageShareData({
                title: app.gooodinfo.goodsname,
                desc: data.res.share_desc,
                link: window.location.href,
                imgUrl: app.gooodinfo.goods_thumb,
                success: function() {
                console.log("设置成功")
                },
                cancel: function(res) {
                console.log('分享失败');
                },
                complete: function(res) {
                console.log("complete1");
                },
                trigger: function(res) {
                console.log("trigger1");
                }
                })
                wx.updateTimelineShareData({
                title: app.gooodinfo.goodsname,
                desc: data.res.share_desc,
                link: window.location.href,
                imgUrl: app.gooodinfo.goods_thumb,
                success: function(res) {
                console.log('设置成功');
                },
                cancel: function(res) {
                console.log('分享失败');
                },
                complete: function(res) {
                console.log("complete2");
                },
                trigger: function(res) {
                console.log("trigger2");
                }
                });
                */
                //预处理下分享数据
                let share_title = "";
                let share_desc = "";
                let share_img = "";
                //商品分享标题设置取设置，否则取商品名称
                if (!!app.info.share_title) {
                  share_title = app.info.share_title;
                } else {
                  share_title = app.info.title;
                }
                //商品描述设置取设置，否则取模板上面的
                if (!!app.info.share_description) {
                  share_desc = app.info.share_description;
                } else {
                  share_desc = app.info.description;
                }
                //商品设置取商品设置，否则取商品缩略
                if (!!app.info.share_cover_image) {
                  share_img = app.info.share_cover_image;
                } else {
                  share_img = app.info.cover_image;
                }
                //旧的版本还有分享成功回调。不过不知道还能用多久
                wx.onMenuShareAppMessage({
                  title: share_title, // 分享标题
                  desc: share_desc, // 分享描述
                  link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: share_img, // 分享图标
                  type: "", // 分享类型,music、video或link，不填默认为link
                  dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
                  success: function() {
                    // 用户点击了分享后执行的回调函数
                    //alert("分享执行成功了1")
                    var link = escape(window.location.href);
                    var desc = share_desc;
                    var title = share_title;
                    var imgUrl = share_img;
                    var share_type = "1";
                    var pathUrl =
                      api_url +
                      `action=notify_share_success&id=${id}&token=${token}&link=${link}&desc=${desc}&title=${title}&imgUrl=${imgUrl}&share_type=${share_type}`;
                    app.$http
                      .request({
                          url: pathUrl,
                        },
                        "GET"
                      )
                      .then((res) => {
                        console.log("notify_share_success", res);
                      });
                  },
                });
                wx.onMenuShareTimeline({
                  title: share_title, // 分享标题
                  link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: share_img, // 分享图标
                  success: function() {
                    // 用户点击了分享后执行的回调函数
                    //alert("分享执行成功了2")
                    var link = escape(window.location.href);
                    var desc = "";
                    var title = data.res.share_title;
                    var imgUrl = data.res.share_img;
                    var share_type = "2";
                    var pathUrl =
                      api_url +
                      `action=notify_share_success&id=${id}&token=${token}&link=${link}&desc=${desc}&title=${title}&imgUrl=${imgUrl}&share_type=${share_type}`;
                    app.$http
                      .request({
                          url: pathUrl,
                        },
                        "GET"
                      )
                      .then((res) => {
                        console.log("notify_share_success", res);
                      });
                  },
                });
              });
            }
          });
      },
    },
    created() {
      // 页面初始化
      this.initshow()
    }
  };
</script>


<style scoped="scoped">
  .top {
    width: 100%;
  }

  .top-img {
    width: 100%;
  }

  .banner {
    width: 100%;
    padding-top: 10px;
    display: flex;
    flex-wrap: wrap;
  }

  .banner-item {
    width: 50%;
    padding: 10px 0;
  }

  .item-in {
    width: 70%;
    margin: auto;
  }

  .wai-img {
    width: 100%;
    padding: 5px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
  }

  .in-img {
    width: 100%;
  }

  .in-name {
    text-align: center;
  }

  .in-price {
    text-align: center;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/shop.vue